<div class="modal-header">
  <div class="header-content">
    <h2 mat-dialog-title class="clean-title">{{ dialogTitle }}</h2>
    <span class="ref-badge"><i class="fa-solid fa-hashtag"></i> {{ data.rowData['v_ladings.alternate_reference'] || data.lading_uuid }}</span>
  </div>
</div>

<mat-dialog-content class="mat-typography custom-scroll no-pad-top">
  
  <mat-tab-group animationDuration="0ms" (selectedTabChange)="onTabChange($event)" class="custom-tabs">
    
    <mat-tab label="Timeline Details">
      <div class="tab-body">
        
        <div class="action-card mt-3">
          <div class="action-card-header">
            <i class="fa-solid fa-calendar-plus text-primary"></i> 
            <span>Record a Status Event</span>
          </div>
          
          <form [formGroup]="addForm" (ngSubmit)="addEvent()" class="modern-form">
            <div class="form-grid-3">
              <mat-form-field appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="lading_status" required>
                  <mat-option *ngFor="let opt of statusOptions" 
                              [value]="opt.value" 
                              [disabled]="opt.disabled"
                              [matTooltip]="opt.reason" 
                              [matTooltipDisabled]="!opt.disabled">
                    {{ opt.value }} <span *ngIf="opt.disabled" class="text-muted text-small">(Exists)</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Local Time</mat-label>
                <input matInput type="datetime-local" formControlName="local_time">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Time Zone</mat-label>
                <input matInput type="text" formControlName="time_zone_id" placeholder="America/Chicago">
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Note (Optional)</mat-label>
              <textarea matInput formControlName="lading_status_note" rows="2" placeholder="Add context..."></textarea>
            </mat-form-field>

            <div class="form-actions right">
              <button mat-flat-button color="primary" class="shadow-sm btn-tall px-4" type="submit" [disabled]="addForm.invalid || saving">
                {{ saving ? 'Adding...' : 'Add Event' }}
              </button>
            </div>
          </form>
        </div>

        <h3 class="section-header mt-4">Timeline History <span class="count-pill" *ngIf="events.length">{{ events.length }}</span></h3>

        <div *ngIf="loading" class="empty-state">Loading timeline...</div>
        <div *ngIf="!loading && events.length === 0" class="empty-state">
          <div class="empty-icon-wrapper">
            <i class="fa-duotone fa-clock-rotate-left"></i>
          </div>
          <h4>No events recorded</h4>
          <p>Use the form above to log the first status for this work order.</p>
        </div>

        <div class="timeline-container" *ngIf="!loading && events.length > 0">
          <div class="timeline-item" *ngFor="let evt of events; let i = index">
            
            <div class="timeline-node" [ngClass]="{'latest-node': i === 0}"></div>

            <mat-card class="timeline-card shadow-sm border-slate" [class.editing]="editingUuid === evt.lading_status_timeline_uuid">
              
              <mat-card-content *ngIf="editingUuid !== evt.lading_status_timeline_uuid" class="read-mode">
                <div class="card-top">
                  <span class="status-title">{{ evt.lading_status }}</span>
                  <div class="action-buttons">
                    <button mat-icon-button class="text-slate-400 hover-text-primary" (click)="startEdit(evt)" [disabled]="saving">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button mat-icon-button class="text-slate-400 hover-text-danger" (click)="deleteEvent(evt)" [disabled]="saving">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </div>
                
                <div class="event-meta">
                  <span class="meta-tag"><i class="fa-regular fa-clock"></i> {{ formatTimestamp(evt.local_time ?? evt.created) }}</span>
                  <span class="meta-tag" *ngIf="evt.time_zone_id"><i class="fa-solid fa-globe"></i> {{ evt.time_zone_id }}</span>
                </div>
                
                <div class="event-note" *ngIf="evt.lading_status_note">{{ evt.lading_status_note }}</div>
              </mat-card-content>

              <mat-card-content *ngIf="editingUuid === evt.lading_status_timeline_uuid" class="edit-mode">
                <div class="edit-header">
                  <i class="fa-solid fa-pen-to-square text-primary"></i> <strong>Editing Event</strong>
                </div>
                <form [formGroup]="editForm" (ngSubmit)="saveEdit()" class="modern-form mt-2">
                  <div class="form-grid-3">
                    <mat-form-field appearance="outline">
                      <mat-label>Status</mat-label>
                      <mat-select formControlName="lading_status">
                        <mat-option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.value }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Local Time</mat-label>
                      <input matInput type="datetime-local" formControlName="local_time">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Time Zone</mat-label>
                      <input matInput type="text" formControlName="time_zone_id">
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Note</mat-label>
                    <textarea matInput formControlName="lading_status_note" rows="2"></textarea>
                  </mat-form-field>
                  <div class="form-actions right">
                    <button mat-button type="button" class="text-slate-500" (click)="cancelEdit()">Cancel</button>
                    <button mat-flat-button color="accent" class="shadow-sm" type="submit" [disabled]="editForm.invalid || saving">
                      {{ saving ? 'Saving...' : 'Save Changes' }}
                    </button>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Map View">
      <div class="tab-body map-tab-body">
        <div *ngIf="!mapDataLoaded" class="empty-state map-loading">
          <div class="empty-icon-wrapper pulse-anim">
            <i class="fa-solid fa-map-location-dot"></i>
          </div>
          <h4>Gathering Coordinates...</h4>
        </div>
        
        <div *ngIf="mapDataLoaded && mapPoints.length === 0" class="empty-state">
          <div class="empty-icon-wrapper">
            <i class="fa-solid fa-location-xmark"></i>
          </div>
          <h4>No Coordinates Available</h4>
          <p>None of the events in this timeline have GPS coordinates or translatable addresses.</p>
        </div>

        <div id="timeline-map" class="leaflet-container" [class.hidden]="!mapDataLoaded || mapPoints.length === 0"></div>
      </div>
    </mat-tab>

  </mat-tab-group>

</mat-dialog-content>

<div class="modal-footer">
  <button mat-button mat-dialog-close (click)="close()" class="text-slate-500 hover-bg-slate">Close</button>
</div>